import React, { useReducer } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import styled, { css } from 'styled-components';
import { seatStatus, statusColors } from '@src/common/seatMaps';
import { BodyExtraSmallMedium } from '@src/fonts/typography/Typography';
import useTranslate from '../../i18n/useTranslate';
import { LayoutColors } from '@src/core/theme';
import { useWidgetsTheme as theme } from '../../core/hooks';

const SeatMapLegendSelector = () => {
  const { i18n } = useTranslate();
  const actionColor = theme('actionColor');

  const [showStates, toggleShowStates] = useReducer((c) => !c, false);

  return (
    <StatusSubtitleContainer>
      <StatusSubtitleTrigger active={showStates} onClick={() => toggleShowStates()} color={actionColor}>
        <Legend color={actionColor}>{i18n('seatMap_canvas_subtitles')}</Legend>

        <MdKeyboardArrowDown size={22} color={actionColor} />
      </StatusSubtitleTrigger>

      {showStates && (
        <StatusSubtitle>
          {seatStatus.map((name) => (
            <StatusSubtitleItem key={name}>
              <StatusSubtitleItemColor color={statusColors[name]!} />
              <StatusSubtitleItemName>{i18n(name)}</StatusSubtitleItemName>
            </StatusSubtitleItem>
          ))}
        </StatusSubtitle>
      )}
    </StatusSubtitleContainer>
  );
};

export default SeatMapLegendSelector;

const StatusSubtitleContainer = styled.div``;

interface StatusSubtitleTriggerProps {
  active: boolean;
  color: string;
}

const StatusSubtitleTrigger = styled.button<StatusSubtitleTriggerProps>`
  position: relative;
  box-sizing: border-box;
  border: none;
  padding: 6px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: ${LayoutColors.whiteLight};
  border: 1px solid ${({ color }) => color};

  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
`;

const CanvasFloatingElements = css`
  z-index: 1;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.15);
`;

const StatusSubtitle = styled.ul`
  ${CanvasFloatingElements};
  position: absolute;
  margin-top: 8px;
  padding: 10px;
  list-style: none;
`;

const StatusSubtitleItem = styled.li`
  margin-top: 7px;

  &:first-child {
    margin-top: 0;
  }

  > span {
    vertical-align: middle;
  }
`;

interface StatusSubtitleItemColorProps {
  color: string;
}

const StatusSubtitleItemColor = styled.span<StatusSubtitleItemColorProps>`
  display: inline-block;
  margin-right: 9px;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background-color: ${({ color }) => color};
`;

const StatusSubtitleItemName = styled.span`
  ${BodyExtraSmallMedium};
`;

interface LegendProps {
  color: string;
}

const Legend = styled.span<LegendProps>`
  ${BodyExtraSmallMedium};
  color: ${({ color }) => color};
  margin-right: 16px;
`;
